import { render, staticRenderFns } from "./ClosedTicketsTable.vue?vue&type=template&id=78ae2cbe&"
import script from "./ClosedTicketsTable.vue?vue&type=script&lang=js&"
export * from "./ClosedTicketsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports